// Chart1.js
import React from 'react'
import { Bar } from 'react-chartjs-2'

const BarChart = () => {
    const data = {
        labels: ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'],
        datasets: [
            {
                label: 'Productivity',
                backgroundColor: ['#72C77C', '#348D3E', '#A1E9AA', '#B3DEB8'],
                borderColor: ['#72C77C', '#348D3E', '#A1E9AA', '#B3DEB8'],
                borderWidth: 1,
                hoverBackgroundColor: 'rgba(52,141,62,0.4)',
                hoverBorderColor: 'rgba(52,141,62,1)',
                data: [65, 59, 80, 81, 56, 55],
                tension: 0.1,
            },
            {
                label: 'Communication',
                backgroundColor: '#348D3E',
                borderColor: '#348D3E',
                borderWidth: 1,
                hoverBackgroundColor: 'rgba(52,141,62,0.4)',
                hoverBorderColor: 'rgba(52,141,62,1)',
                data: [65, 59, 80, 81, 56, 55],
                tension: 0.1,
            },
            {
                label: 'Creativity',
                backgroundColor: '#A1E9AA',
                borderColor: '#A1E9AA',
                borderWidth: 1,
                hoverBackgroundColor: 'rgba(52,141,62,0.4)',
                hoverBorderColor: 'rgba(52,141,62,1)',
                data: [65, 59, 80, 81, 56, 55],
            },
            {
                label: 'Others',
                backgroundColor: '#B3DEB8',
                borderColor: '#B3DEB8',
                borderWidth: 1,
                hoverBackgroundColor: 'rgba(52,141,62,0.4)',
                hoverBorderColor: 'rgba(52,141,62,1)',
                data: [65, 59, 80, 81, 56, 55],
            },
        ],
    }

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        barPercentage: 0.4,
        plugins: {
            legend: {
                display: true, // Hide legend
                position: 'top',
                align: 'end',
                labels: {
                    paddingBottom: 10,
                    padding: 15,
                    pointStyle: 'circle',
                    usePointStyle: true,
                },
            },
        },
        scales: {
            x: {
                stacked: true,
                display: true, // Hide x-axis
            },
            y: {
                display: true,
                stacked: true,
                grid: {
                    display: true,
                },
                ticks: {
                    display: false,
                },
                title: {
                    display: true,
                    text: 'Average',
                    color: '#191',
                    font: {
                        position: 'right',
                        family: 'Times',
                        size: 20,
                        style: 'normal',
                        lineHeight: 1.2,
                    },
                    padding: { top: 30, left: 0, right: 0, bottom: 0 },
                },
            },
        },
    }

    return <Bar data={data} options={options} />
}

export default BarChart
